/**
 * Shared "Mindful Minerals | OreVital" brand strip + dark "Meet the Science"
 * hero used at the top of every public-facing left column (Dealer Home,
 * Blog, etc.). Single source of truth so we don't drift across pages.
 */
export default function BrandHero() {
  return (
    <div className="space-y-3">
      <div className="rounded-t-2xl bg-emerald-200/70 px-4 sm:px-5 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5 font-semibold text-zinc-800 tracking-tight" data-testid="brand-strip">
          <img src="https://uploads.orevital.com/mm-favicon.png" alt="Mindful Minerals" className="h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white object-cover ring-2 ring-white shadow-sm" />
          <span className="whitespace-nowrap">Mindful Minerals</span>
          <span className="text-zinc-400 mx-1">|</span>
          <img src="https://uploads.orevital.com/ov-favicon.png" alt="OreVital" className="h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white object-cover ring-2 ring-white shadow-sm" />
          <span>OreVital</span>
        </div>
        <div className="hidden sm:block text-xs text-zinc-700">
          Peptide Intelligence™ &amp; Transdermal Enhancement Performance Peptides
        </div>
      </div>

      <div className="rounded-2xl bg-zinc-900 text-white px-5 sm:px-8 py-7 min-h-[180px] sm:min-h-[200px] flex flex-col justify-center">
        <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight leading-tight">
          Meet the <span className="text-emerald-400">Science</span> Behind the Results
        </h2>
        <p className="mt-2 text-sm text-zinc-300 max-w-xl">
          <span className="text-emerald-400 font-semibold">Peptide Intelligence™</span>{" "}
          powered by transdermal mineral innovation
        </p>
      </div>
    </div>
  );
}
